import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoVeiculos = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tipoVeiculos`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_VEICULOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoVeiculos;